<p-toast></p-toast>
<div style="background-color: rgb(0, 152, 223); height: 5px;" class="ng-star-inserted"></div>
<div class="container-fluid mt-3">
  <p-panel header="Monitoramento de Job" styleClass="p-shadow-3">
    <p-table #dt [value]="dados" selectionMode="multiple" [loading]="loading" [columns]="cols" [autoLayout]="true" [rows]="50"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines">
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3" style="padding: 10px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td *ngFor="let col of cols">
            {{dados[col.field]}}
          </td>
        </tr>
      </ng-template>
    </p-table>